import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import "./styles/themeToggle.css";

const STORAGE_KEY = "portfolio-theme";

const ThemeToggle = () => {
	const getInitialTheme = () => {
		if (typeof window === "undefined") {
			return "light";
		}

		const storedTheme = window.localStorage.getItem(STORAGE_KEY);
		if (storedTheme === "light" || storedTheme === "dark") {
			return storedTheme;
		}

		return window.matchMedia("(prefers-color-scheme: dark)").matches
			? "dark"
			: "light";
	};

	const [theme, setTheme] = useState(getInitialTheme);

	useEffect(() => {
		document.documentElement.dataset.theme = theme;
		window.localStorage.setItem(STORAGE_KEY, theme);
	}, [theme]);

	const toggleTheme = () => {
		setTheme((current) => (current === "dark" ? "light" : "dark"));
	};

	return (
		<button
			type="button"
			className="theme-toggle-button"
			onClick={toggleTheme}
			aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
			title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
		>
			<FontAwesomeIcon icon={theme === "dark" ? faSun : faMoon} />
		</button>
	);
};

export default ThemeToggle;
